// constants for idea statuses
export const NEW_OUT_DATE = {
  id: -2,
  title: 'განხილვის პროცესში / ვადაგადაცილებული'
};
export const NEW = {
  id: 2,
  title: 'ახალი'
};
export const VOTE_IN_PROGRESS = {
  id: 3,
  title: 'მიმდინარე'
};
export const VOTE_IN_PROGRESS_OUT_DATE = {
  id: -3,
  title: 'მიმდინარე / ვადაგადაცილებული'
};
export const VIOLATED = {
  id: 4,
  title: 'დაბლოკილი'
};
export const VIOLATED_PUBLISHED = {
  id: 5,
  title: 'დაბლოკილი / გამოქვეყნებული'
};
export const VOTE_COMPLETED = {
  id: 6,
  title: 'დასრულებული'
};
export const VOTE_COMPLETED_OUT_DATE = {
  id: -6,
  title: 'დასრულებული / ვადაგადაცილებული'
};
export const VOTE_INCOMPLETE = {
  id: 7,
  title: 'არშემდგარი'
};
export const DISCUSS_APPROVED = {
  id: 8,
  title: 'განხილვის პროცესში'
};
export const DISCUSS_APPROVED_OUT_DATE = {
  id: -8,
  title: 'განხილვის პროცესში / ვადაგადაცილებული'
};
export const DISCUSS_REJECTED = {
  id: 9,
  title: 'განხილვამდე უარყოფილი'
};
export const DISCUSS_REJECTED_OUT_DATE = {
  id: -9,
  title: 'განხილვამდე უარყოფილი / ვადაგადაცილებული'
};
export const DISCUSS_REJECTED_AND_WITH_LEGAL_GROUND = {
  id: 10,
  title: 'უარყოფილი'
};
export const DEFECTED = {
  id: 11,
  title: 'ხარვეზი'
};
export const DEFECTED_OUT_DATE = {
  id: -11,
  title: 'ხარვეზი / ვადაგადაცილებული'
};
export const DEFECT_ACCEPTED = {
  id: 12,
  title: 'შესწორებული'
};
export const DEFECT_ACCEPTED_OUT_DATE = {
  id: -12,
  title: 'შესწორებული / ვადაგადაცილებული'
};
export const DISCUSS_FINISHED = {
  id: 13,
  title: 'განხილული'
};
export const DISCUSS_FINISHED_OUT_DATE = {
  id: -13,
  title: 'განხილული / ვადაგადაცილებული'
};
export const DISCUSS_FINISHED_ACCEPTED = {
  id: 14,
  title: 'მერის თანხმობა'
};
export const DISCUSS_FINISHED_ACCEPTED_OUT_DATE = {
  id: -14,
  title: 'მერის თანხმობა / ვადაგადაცილებული'
};
export const DISCUSS_FINISHED_ACCEPTED_WITH_LEGAL_GROUND = {
  id: 15,
  title: 'შეთანხმებული'
};
export const DISCUSS_FINISHED_REJECTED = {
  id: 16,
  title: 'მერის უარყოფა'
};
export const DISCUSS_FINISHED_REJECTED_OUT_DATE = {
  id: -16,
  title: 'მერის უარყოფა / ვადაგადაცილებული'
};
export const DISCUSS_FINISHED_REJECTED_WITH_LEGAL_GROUND = {
  id: 17,
  title: 'უარყოფილი'
};



// WEBPACK FOOTER //
// /opt/app-root/src/src/app/services/admin/constants.ts